import { render } from "./InvoiceDetail.vue?vue&type=template&id=6cb568c0&scoped=true"
import script from "./InvoiceDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceDetail.vue?vue&type=script&lang=js"

import "./InvoiceDetail.vue?vue&type=style&index=0&id=6cb568c0&scoped=true&lang=css"
import "./InvoiceDetail.vue?vue&type=style&index=1&id=6cb568c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb568c0"]])

export default __exports__